const _import = require('../import-' + process.env.NODE_ENV)

const freshOrderRouter = [
  {
    path: '/freshOrder/Index',
    name: 'freshOrderIndex',
    component: _import('freshOrder/Index'),
    meta: {
      title: '生鲜订货',
      keepAlive: true,
      auth: true
    }
  },
  {
    path: '/freshOrder/BarcodeOrder',
    name: 'freshOrderBarcode',
    component: _import('freshOrder/BarcodeOrder'),
    meta: {
      title: '生鲜订货',
      auth: true
    }
  },
  {
    path: '/freshOrder/CheckDetail',
    name: 'freshOrderCheckDetail',
    component: _import('freshOrder/CheckDetail'),
    meta: {
      title: '生鲜订货',
      auth: true
    }
  },
  {
    path: '/freshOrder/OrderList',
    name: 'freshOrderList',
    component: _import('freshOrder/OrderList'),
    meta: {
      title: '订货历史记录',
      auth: true
    }
  },
  {
    path: '/freshOrder/OrderDetail',
    name: 'freshOrderDetail',
    component: _import('freshOrder/OrderDetail'),
    meta: {
      title: '订货历史详情',
      auth: true
    }
  }
]
export default freshOrderRouter



// WEBPACK FOOTER //
// ./src/router/freshOrder/index.js